import { Link } from "react-router-dom";
import { User, ChevronRight } from "lucide-react";
import EmpresaBrand from "@/components/EmpresaBrand";
import { fmtFecha } from "@/lib/format";

export default function ListadoCabecera({ empresa, trabajador, desde, hasta, titulo, perfilUrl }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-indigo-100 bg-white shadow-sm">
      <div className="border-b border-indigo-50 p-4">
        <EmpresaBrand empresa={empresa} />
      </div>
      <div className="flex flex-wrap items-start justify-between gap-3 bg-gradient-to-r from-slate-50 to-indigo-50/50 px-4 py-3">
        <div>
          {titulo && <p className="text-sm font-semibold text-indigo-900">{titulo}</p>}
          {(desde || hasta) && (
            <p className="text-xs text-indigo-700/70">
              Periodo: <strong>{fmtFecha(desde)}</strong> — <strong>{fmtFecha(hasta)}</strong>
            </p>
          )}
        </div>
      </div>
      {trabajador && (
        <div className="border-t border-emerald-100 bg-gradient-to-r from-emerald-50/80 to-teal-50/80 px-4 py-3">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 text-white shadow-sm">
              <User className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <div className="min-w-0">
              <p className="font-medium text-emerald-950">{trabajador.nombre}</p>
              <p className="text-xs text-emerald-800/80">{trabajador.email}</p>
              <div className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-[11px] text-emerald-700/90">
                {trabajador.centro && <span>Centro: {trabajador.centro}</span>}
                {trabajador.departamento && <span>Depto: {trabajador.departamento}</span>}
                {trabajador.puesto && <span>Puesto: {trabajador.puesto}</span>}
                {trabajador.tipo_contrato && <span>Contrato: {trabajador.tipo_contrato}</span>}
              </div>
              {perfilUrl && (
                <Link
                  to={perfilUrl}
                  className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-emerald-700 hover:text-emerald-900"
                >
                  Ver toda mi información
                  <ChevronRight className="h-3.5 w-3.5" />
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
